/**
 * @module views\sys\charts
 */
import Vue from "vue";
import Component from "vue-class-component";

import highcharts from "highcharts";
import GhBase from "@/components/ghBase";
import { Watch } from "vue-property-decorator";
import { TreeNode } from "element-ui/types/tree";
import GhTablePage from "@/components/ghTablePage/ghTablePage";

@Component
export default class Charts extends GhBase {
  private tabIndex = 0;

  private cls = "";

  private args = { keyword: "" };

  private detailArgs = { foreign_key: "" };
  private tabs: IGhTab[] = [
    { title: "图表管理" },
    { title: "图表配置", drawer: false }
  ];

  private detailTabs: IGhTab[] = [{ title: "数据项配置", drawer: false }];

  private selectedNode = {};

  @Watch("selectedNode")
  private observeNode() {
    let node = this.selectedNode as TreeNode<String, IndexObject>;
    if (node.key && node.data && node.data.Table) {
      // let page = this.$refs.detail_table as GhTablePage;
      console.log(node.data);
      this.cls = node.data.Table;
    }
  }
  @Watch("tabIndex")
  private observeTab() {
    this.detailTabs[0].drawer = this.tabIndex === 1;
  }

  private beforeSave(item) {}

  private beforeDetailSave(item) {
    if (this.current && this.current.Id) {
      item.ForeignKey = this.current.Id;
    }
  }

  private current: IndexObject = {};
  private viewItem(item) {
    this.tabIndex += 1;
    this.current = item;
    this.detailArgs.foreign_key = item.Id;
  }

  protected get TestValue() {
    let s = super.TestValue;

    s = s + "     I from Chart";
    return s;
  }
}
